import React from 'react'
import '../styles/about.css'

function About() {
  return (
    <div className='about1'>
      <div className='content'>
        <h2>About US</h2>
        <h1>MORE THAN GREAT FOOD</h1>
        <p>
          There’s nothing cookie-cutter about largo's Pizza and our franchise partners. Not the pizza and definitely not the people. A career with largo's Pizza or one of local independently owned franchisees is for those that stand out; we’re constantly pushing boundaries and helping each other become the best we can be. If you’re ready to live life unboxed, you’re ready for a career with the largo's Pizza Brand.
        </p>
      </div>
    </div>
  )
}

export default About